/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type AssignmentSortFieldEnum =
  (typeof AssignmentSortFieldEnum)[keyof typeof AssignmentSortFieldEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssignmentSortFieldEnum = {
  BookedTo: 0,
  Status: 1,
  Assignee: 2,
  CaseType: 3,
  FromAddress: 4,
} as const;
